const data = {
	"width": 24,
	"height": 24,
	"body": "<g id=\"feArrowUp0\" fill=\"none\" fill-rule=\"evenodd\" stroke=\"none\" stroke-width=\"1\"><g id=\"feArrowUp1\" fill=\"currentColor\"><path id=\"feArrowUp2\" d=\"m4 15l8-8l8 8l-2 2l-6-6l-6 6z\"/></g></g>"
};
exports.__esModule = true;
exports.default = data;
